import { styled, DialogTitle, DialogContent, Button, Link, Theme } from '@material-ui/core';

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  textAlign: 'end',
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  gap: '32px',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '250px',
}));

export const ErrorStyledDiv = styled('div')(() => ({
  position: 'relative',
  margin: 'auto',
  height: '45px',
}));

export const StyledButton = styled(Button)(() => ({
  textTransform: 'unset',
  textDecoration: 'underline',
}));

export const StyledLink = styled(Link)<Theme>(({ theme }) => ({}));
